/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useCookies } from "react-cookie";
import Config from "data/config";
// import { Logger } from "cms/utils/log/logger";

const SessionCheck = function (props) {
    const children = props?.children;
    const [authenticationState, setAuthenticationState] = useState("pending");
    const { isLoggedIn, verifySession } = useAuth();

    const [,, removeCookie] = useCookies("simplicity_admin");
    
    let quantity = 5;
    const qtyAsSeconds = 1000 * 60; // ...calculate in milliseconds
    const qtyAsMinutes = qtyAsSeconds * 60;
    // let timeunit = quantity * asSeconds;
    let timeunit = quantity * qtyAsMinutes;

    let component;
    let checkTime = quantity * timeunit;

    useEffect(() => {
        const stopTimer = function () {
            clearInterval(timer);
        };
        
        const destroySession = () => {
            removeCookie('simplicity_admin', {
                path: '/',
                domain: Config.COOKIE_DOMAIN,
            });
        }
        
        const checkNow = async () => {
            /*
               Will check access token expiry.
               May communicate with server to refresh
               Or cause a logout
             */
            return await verifySession();
        };
        
        let timer = setInterval(() => {
            checkNow()
                .then((isValid) => {
                    if (!isValid) {
                        stopTimer();
                        destroySession();
                    }
                });
        }, checkTime);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            setAuthenticationState("authenticated");
        } else {
            setAuthenticationState("not authenticated");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    // show children or login
    if (authenticationState === "authenticated") {
        component = children;
    } else {
        //TODO: show unauthenticated prompt
        component = <Fragment />;
    }

    return <Fragment>{component}</Fragment>;
};

export { SessionCheck };
